import {Text} from '@rdcomponents/text/text';
import {Card, Skeleton} from 'antd';

import {AdditionalInfo} from '../../../../../../layout/additional-info/additional-info';
import {FormattedNumber} from '../../../../../../provider/locale/formatted-number';
import {Locale} from '../../../../../../provider/locale/locale';
import {RatingDynamicsCompaniesStatsDataType} from '../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

import * as styles from './rating-history-average-rating-card.scss';

type PropsType =
    | {
          ratingData: RatingDynamicsCompaniesStatsDataType['medianRatingsAverage']['overallAverage'];
          loading?: never;
      }
    | {
          loading: true;
          ratingData?: never;
      };

export function RatingHistoryAverageOverallRatingCard(props: PropsType): JSX.Element {
    const {ratingData} = props;

    return (
        <Card>
            <div className={styles.RatingHistoryAverageRating}>
                <AdditionalInfo
                    leftNode={
                        <Text
                            block
                            secondary
                            small
                            stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__OVERALL_AVERAGE_RATING"
                        />
                    }
                >
                    <Locale stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMICS__OVERALL_MEDIAN_RATING_YEAR_HINT" />
                </AdditionalInfo>

                {ratingData ? (
                    <Text block bolder className={styles.RatingHistoryAverageRating_value}>
                        <FormattedNumber options={{maximumFractionDigits: 1}} value={ratingData} />
                    </Text>
                ) : (
                    <Skeleton.Input active size="large" />
                )}
            </div>
        </Card>
    );
}
